import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDuUgxQNuTYigztvwgqLcWw2O4zSQaAUw8",
    authDomain: "personal-website-c0450.firebaseapp.com",
    projectId: "personal-website-c0450",
    storageBucket: "personal-website-c0450.appspot.com",
    messagingSenderId: "253434006283",
    appId: "1:253434006283:web:261ee20806dde15214b00e",
    measurementId: "G-0J9TBDWCM0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
window.analytics = getAnalytics(app);